module.exports = __webpack_public_path__ + "img/badge-confirmation-general.f194ed80.svg";